import Cookies from 'js-cookie';

(function($, window){

    $.fn.TimedPopup = function(options) {
      return this.each(function(){
        var settings = $.extend({
         cookieValue: 'sent-away',
         expires: 1,
         cookieNameAttr: 'data-timed-popup',
         closeSelector: '[data-timed-popup-close]',
         delaySelector: 'data-timed-popup-delay',
         delay: 0,
        }, options );

        var $popup = $(this);
        var cookieName = $popup.attr(settings.cookieNameAttr);
        var cookieVal = Cookies.get(cookieName);

        if (options == undefined) {
          settings.delay = $popup.attr(settings.delaySelector);
        }

        if(!cookieVal || cookieVal !== settings.cookieValue || options) {
            if($(this).attr('data-timed-popup-auto-show') == 'true') {
                window.setTimeout(function(){
                        $popup.addClass('timed-popup--ready');

                        var id = $popup.attr('id');
                        //MicroModal.show(id);

                        window.setTimeout(function(){
                            $popup.addClass('timed-popup--visible');
                            var $popupSubmit = $popup.find("button[type=submit]");
                            var $popupInput = $popup.find("input[type=email]");

                            if($popupInput.val() != '') {
                            $popupSubmit.removeAttr('disabled');
                            } else {
                            $popupSubmit.attr('disabled', 'true'); //submit start disabled
                            }

                            $popupInput.on('change keyup', function(e) {

                            if($popupInput.val() != '') {
                                $popupSubmit.removeAttr('disabled');
                            } else {
                                $popupSubmit.attr('disabled', 'true');
                            }
                            })

                        }, 500);

                    $popup.find(settings.closeSelector).click(function(){
                        Cookies.set(cookieName, settings.cookieValue, { expires: settings.expires });
                        $popup.removeClass('timed-popup--visible timed-popup--ready');
                        //MicroModal.close(id);
                    });
                }, settings.delay);
            } else {
                $(this).attr('data-timed-popup-auto-show', true ); // Switch after first load
            }
        }
      });
    }

  })(jQuery, window);
